import { FeatureImageProps } from '@/assets/content/products/type'
import { Flex } from 'antd'
import Image from '@/components/image'
import styles from './style.module.scss'

export default function ImageList({ content }: { content: FeatureImageProps['content'] }) {
  return (
    <Flex vertical className={styles.imageList}>
      {content.map((item, index) => (
        <div className={styles.imageItem} key={index}>
          {item.title && <div className={styles.title}>{item.title}</div>}
          <Flex vertical className={styles.images}>
            {item.images.map(image => (
              <Image key={image} src={image} alt={`${item.title}-${index}`} />
            ))}
          </Flex>
        </div>
      ))}
    </Flex>
  )
}
